<template>

  <div>
    <v-data-table :headers="headers"
                  :items="items"
                  :pagination.sync="pagination_"
                  :total-items="totalItems"
                  :rows-per-page-items="paginationOptions"
                  :loading="loading">
      <v-progress-linear slot="progress"
                         color="primary"
                         indeterminate="indeterminate"></v-progress-linear>
      <template slot="items" slot-scope="props" v-show="!loading">

        <!-- ID -->
        <td :class="$vuetify.breakpoint.name">
          <ExternalId :id="props.item.id" :path="getPath(props.item)" />
        </td>

        <!-- LOGO -->
        <td :class="$vuetify.breakpoint.name">
          <div class="d-flex align-center justify-center">
            <img v-if="props.item.logoURL" :src="props.item.logoURL" alt="Logo" style="width: 44px; height: 44px; object-fit: contain;">
            <span v-else>-</span>
          </div>
        </td>

        <!-- NAME -->
        <td :class="$vuetify.breakpoint.name" class="wide-column"><b>{{ props.item.name }}</b></td>

        <!-- TYPE (COMPETITION/TOURNAMENT) -->
        <td :class="$vuetify.breakpoint.name">{{ props.item.isTournament ? 'Tournament' : 'Competition' }}</td>

        <!-- FEDERATION -->
        <td :class="$vuetify.breakpoint.name">{{ props.item.federationID }}</td>

        <!-- REGION -->
        <td :class="$vuetify.breakpoint.name">{{ props.item.regionAlias }}</td>

        <!-- CATEGORY -->
        <td :class="$vuetify.breakpoint.name">{{ props.item.categoryID }}</td>

        <!-- SEASON -->
        <td :class="$vuetify.breakpoint.name">{{ props.item.seasonID.substr(props.item.seasonID.length - 9, props.item.seasonID.length) || 'current' }}</td>

        <!-- START DATE -->
        <td :class="$vuetify.breakpoint.name">{{  props.item.startDate ? formatDate(props.item.startDate) : '' }}</td>

        <!-- END DATE -->
        <td :class="$vuetify.breakpoint.name">{{ props.item.endDate ? formatDate(props.item.endDate) : '' }}</td>

        <!-- BUTTONS -->
        <v-layout justify-end>
          <td class="buttons" :class="$vuetify.breakpoint.name">
            <v-icon class="clubs-button mr-1" title="Edit" @click="edit(props.index)">mdi-pencil</v-icon>
            <ProxyDeleteButton class="clubs-button" @click="del(props.item)"></ProxyDeleteButton>
          </td>
        </v-layout>

      </template>
    </v-data-table>
  </div>

</template>

<script>

import ProxyDeleteButton from '../common/ProxyDeleteButton'
import ExternalId from '../tables/ExternalId.vue'

export default {
  name: 'Table',
  components: {
    ProxyDeleteButton,
    ExternalId
  },
  props: [
    'headers',
    'items',
    'pagination',
    'paginationOptions',
    'totalItems',
    'loading'
  ],
  methods: {
    edit (index) {
      this.$emit('edit', index)
    },
    del (item) {
      this.$emit('del', item)
    },
    formatDate (date) {
      return new Date(date).toLocaleString(`${this.$localeRegion}-${this.$country}`)
    },
    getPath (item) {
      if (item.isTournament) return '/tournament/' + item.id
      return '/competition/' + item.id
    }
  },
  computed: {
    pagination_: {
      get () {
        return this.pagination
      },
      set (v) {
        window.scrollTo(0, 0)
        this.$emit('paginationUpdate', v)
      }
    }
  }
}

</script>

<style lang="scss" scoped>

td {
  &.xs {
    font-size: 11px !important;
    padding: 0 6px !important;
  }
}

.wide-column {
  min-width: 200px;
}

.buttons {
  width: 120px;
  align-content: center;
}

</style>



// WEBPACK FOOTER //
// src/components/competitions/Table.vue